export enum BlobCategory {
  ProfilePicture = 'profile-picture',
  PromptImage = 'prompt-image',
}
